module.exports = __webpack_public_path__ + "static/media/two.fd26f022.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/two.ogg
// module id = 128
// module chunks = 0